<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->
		
		<!-- 弹框 -->
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer"
			  :with-header="false" 
						:direction='direction2'
						:modal-append-to-body="modal"
					size='350px'> 
					  <bottomnav :activepage='16'></bottomnav> 
			</el-drawer> 
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer2"
			  :with-header="false" 
						:direction='direction'
						size='240px'
						:modal-append-to-body="modal"> 
					  <leftnav :isCollapse='isCollapse' :activenav='"3-4"'  :curindex='4'></leftnav>
			</el-drawer> 
			<span class="screen" @click="drawer2 = true"  ><i class="el-icon-s-unfold"></i>菜单栏</span> 
		<!-- 弹框 -->	
		
		<div class="por" style="background-color: #041034;height:100%;">
			<div class="index-swiper centerpage">
				<h2 class="title dataswipertitle" @click="drawer = true">{{userdata.cityText}}{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2>
				<div class="indexflex zhaoshangmap">
					 <div class="col2h transparentbg zdcyl_analysis">
							<h3 class="swiper_title">补链强链环节分析</h3> 
							<div class="zdcyl_analysis_list">
								<ul class="flexcss">
									<li>
										<h4>市场机会</h4>
										<div class="zdcyl_analysis_listbox boxbg1">大</div>
									</li>
									<li>
										<h4>发展动力</h4>
										<div class="zdcyl_analysis_listbox boxbg1">强	</div>
									</li>
									<li>
										<h4>进入壁垒</h4>
										<div class="zdcyl_analysis_listbox boxbg2">高</div>
									</li>
									<li>
										<h4>进入时机</h4>
										<div class="zdcyl_analysis_listbox boxbg2">好</div>
									</li>
								</ul>
							</div>
							<div class="zdcyl_analysis_content"> 
								<p><strong>市场机会很大：</strong>医疗器械市场2016年到2022年的市场增量达7300亿元，年均复合增长率为20%，未来市场增量大、增速快，市场机会很大。</p>
								<p><strong>老龄化加剧和分级诊疗等带来市场需求、政策鼓励医疗器械创新并且利好国产替代、人工智能等技术的飞速进步是三个主要驱动力：</strong>人口老龄化加剧、分级诊疗落实和政府对社会办医的鼓励，使个人和基层医疗机构对医疗器械的需求大增；在此背景下，国家颁布政策鼓励医疗器械创新和国产医疗器械发展，各地方政府积极响应；此外，互联网、大数据、人工智能等新技术与医疗器械产业的深度融合，为产业的升级和创新发展带来前所未有的机会。</p>
								<p><strong>行业进入壁垒高：</strong>行业技术壁垒、政策壁垒和资金壁垒高，竞争壁垒中等。</p>
								<p><strong>行业整体处于成长期中期，进入时机好：</strong>医疗器械产业已经发展了一段时间，整体处于成长期中期，但是人工智能等“新技术”的发展使医疗器械这个“老产业”焕发出新活力，整体来看是企业进入投资的好时机。</p>
								<p><strong>综合评估：</strong>投资价值评级为<strong>四颗星</strong>，投资建议为<strong>重点推荐</strong></p> 
							</div>
						</div>
						<div class="col5 zdcyl_cyl">
							<ul class="zdcyl_cly_nav">
								<li class="" @click="clynav=1"  :class="clynav==1?'navbg':''">医药制造</li>
								<li class="" @click="clynav=2"  :class="clynav==2?'navbg':''">医疗器械</li> 
								<li class="" @click="clynav=3"  :class="clynav==3?'navbg':''">新能源汽车</li>
							<!-- 	<li class="" @click="clynav=4"  :class="clynav==4?'navbg':''">量子通信产业链</li>
								<li class="" @click="clynav=5"  :class="clynav==5?'navbg':''">网络信息安全产业链</li>
								<li class="" @click="clynav=6"  :class="clynav==6?'navbg':''">计算机视觉产业链</li> -->
							</ul> 
							<ul class="zdcyl_cly_chartnav">
								<li class="" @click="clychartnav=1"  :class="clychartnav==1?'navbg':''">产业链全景图</li>
								<li class="" @click="clychartnav=2"  :class="clychartnav==2?'navbg':''">产业链现状图</li>  
							</ul> 
							<div class="zdcyl_clychart1 " v-show="clychartnav==1"><img src="../../../assets/img/cyl1.png" /></div>
							<div class="zdcyl_clychart2" v-show="clychartnav==2"><img src="../../../assets/img/cyl1.png" /> </div>
						</div>
						<div class="col2h  ">
							<div class="zdcyl_enterprise transparentbg">
								<h3 class="swiper_title">补链强链企业推荐</h3>
								<div class="thbox">
									<ul class="flexcss"> 
										<li class="th_list1">企业名称</li>
										<li class="th_list2">省</li>
										<li class="th_list2">市</li> 
										<li class="th_list2">行业</li> 
										<li class="th_list3">联系方式</li>
										</ul> 
										</div>
										<div class="zdcyl_scrollbox">
										<vue-seamless-scroll :data="recommendlist"  :class-option="defaultOption" > <!-- :data="colors"  :class-option="defaultOption" -->  
											<ul class="" v-for="(item,i) in recommendlist" :class="i%2==0?'zdcyl_tab flexcss ':'zdcyl_tab flexcss zdcyl_tabbg'">  <!-- v-for="list in pagedata.investList"-->
												<li class="th_list1">{{item.name}}</li>		
												<li class="th_list2">{{item.province}}</li>
												<li class="th_list2">{{item.city}}</li> 
												<li class="th_list2">{{item.industry}}</li> 
												<li class="th_list3">{{item.Telephone}}</li>
												</ul> 	
										<!-- 	<ul class="zdcyl_tab flexcss zdcyl_tabbg">   
												<li class="th_list1">美的集团股份有限公司</li>		
												<li class="th_list2">广东省</li>
												<li class="th_list2">佛山市</li> 
												<li class="th_list2">商务服务业</li> 
												<li class="th_list3">0755-123154</li>
												</ul> 
											<ul class="zdcyl_tab flexcss ">    
												<li class="th_list1">美的集团股份有限公司</li>		
												<li class="th_list2">广东省</li>
												<li class="th_list2">佛山市</li> 
												<li class="th_list2">商务服务业</li> 
												<li class="th_list3">0755-123154</li>
												</ul> 
										<ul class="zdcyl_tab flexcss zdcyl_tabbg">  
											<li class="th_list1">美的集团股份有限公司</li>		
											<li class="th_list2">广东省</li>
											<li class="th_list2">佛山市</li> 
											<li class="th_list2">商务服务业</li> 
											<li class="th_list3">0755-123154</li>
											</ul> -->
									</vue-seamless-scroll >
								</div> 
							</div>
							<div class="zdcyl_enterprise transparentbg">
								<h3 class="swiper_title">补链强链企业所在地排名</h3>
								<div id="zdcyl_rankchart"></div>
							</div>
							<div class="zdcyl_enterprise transparentbg">
								<h3 class="swiper_title">补链强链企业区域分布</h3>
								<div id="zdcyl_proportion"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import mappng from '../../../assets/images/mapbg.png';
	export default {
		name: 'zhudaochanyelian',
		data() {
			return { 
					isCollapse:false,
					isFullscreen: false,
					direction:"ltr",  //btt
					direction2:"btt",  //btt
					 drawer: false,
						drawer2: false,
						modal:false,	
				title: "主导产业链数字大屏",
				bgcolor: "#041034",
				startVal: 0, //数字滚动开始值
				endVal1: 1425.44, //数字滚动结束 
				usernotionlistsave: [],
				userdata: {}, 
				clynav:1,
				clychartnav:1,
				mapurl: 'map/city/321200.json',
				contodefault: {
					duration: 1000,
					autoplay: true,
				},
				islogin: false,
				flag: true,
				swipernum: 3,
				listdata: [],
				center1: {lng: 119.916321, lat: 32.397677},
				center2:{lng: 119.966102, lat: 32.416398},
				zoom: 13,
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType: [],
				startCharts: null,
				//假数据 
						fixassetsdata:[{name:"重庆",value:101},{name:"成都",value:120},{name:"广州",value:130},{name:"深圳",value:176},{name:"北京",value:187},{name:"上海",value:201}], 
						recommendlist:[
							{name:"比亚迪股份有限公司 ",province:" 广东省",city:'深圳市',	industry:"电气机械及器材制造业",Telephone:'0755-89888888'},
							{name:"奇瑞汽车股份有限公司",province:"安徽省",city:'芜湖市',	industry:"汽车制造业",Telephone:'0553-7533303'},
							{name:"广州小鹏汽车科技有限公司",province:"广东省",city:'广州市',	industry:"研究与试验发展",Telephone:'020-66806680'},
							{name:"科大智能科技股份有限公司",province:"上海市",city:'浦东新区',	industry:"通讯设备、计算机及其他电子设备",Telephone:'021-50809880'},
							{name:"苏州工业园区和顺电气股份有限公司",province:"江苏省",city:'苏州市',	industry:"通讯设备、计算机及其他电子设备",Telephone:'0512-62862622'}, 
							{name:"深圳市恒创睿能环保科技有限公司",province:"广东省",city:'深圳市',	industry:"研究与试验发展",Telephone:'13502577424'},
							{name:"湖南金源新材料股份有限公司",province:"湖南省",city:'益阳市',	industry:"非金属矿物制品业",Telephone:'0737-7828968'},
							{name:"江苏恒瑞医药股份有限公司",province:"江苏省",city:'连云港市',	industry:"医药制造业",Telephone:'0518-81220000'},
							{name:"华东医药股份有限公司",province:"浙江省",city:'杭州市',	industry:"医药制造业",Telephone:'0571-89903300'},
							{name:"上海医药集团股份有限公司",province:"上海市",city:'浦东新区',	industry:"医药制造业",Telephone:'021-63730908'},
							{name:"通化东宝药业股份有限公司",province:"吉林省",city:'通化市',	industry:"医药制造业",Telephone:'0435-5088008'},
							{name:"深圳信立泰药业股份有限公司",province:"广东省",city:'深圳市',	industry:"医药制造业",Telephone:'0755-83867888'},
						],
			}
		},
		props: {
			msg: String,
		},
		computed: {
			defaultOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		mounted() {
			document.getElementById('app').style.background = this.bgcolor;
			this.userdata = this.getuseriformation();
			// console.log(this.userdata);
			// this.getajasdata();  
			this.fixassetsFun('zdcyl_rankchart',this.fixassetsdata);
			this.areagdpFun('zdcyl_proportion',this.fixassetsdata);
		},
		methods: {
			getajasdata() {
				var _this = this;
				// this.bus.$emit('loading', true);
				console.log(this.title);
				this.$axios.get(this.$api.cyl.govementchart.industryland(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(res.data.data); 
					var datd = res.data.data; 
					_this.bus.$emit('loading', false); 
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			}, 
			 
				
			//补链强链企业所在地排名
			fixassetsFun(el,data){ 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el)); 
				var _this = this,xline=[],seriesline=[]; 
				// var datalen=data.length-1;
				for(var i=0;i<data.length;i++){ 
					xline.push(data[i].name);
					seriesline.push(data[i].value);
				};
				// console.log('data',data,xline,seriesline);
				var option = {
					title:{
						text:"",left:25,top:20, textStyle:{color:'#eee',fontSize:16}
					},
					tooltip:{
						show:false,
						trigger: 'axis',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
							color: '#000',
							fontSize: 14,
						},
						formatter: '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'+'内容：'+'{c}'
						},
					color: _this.colors,
					grid: { x: 50, 	y: 10, x2: 10, y2: 20, show: true, 	borderWidth: 0,},
					label: { show: true, position: 'right', valueAnimation: true ,color:'#fff',},
					xAxis: {	type: 'value',axisTick:{show:false},boundaryGap: [0, 0.01],splitLine:{show:false},axisLabel : {formatter: function(){ return "";}}},
					yAxis: { type: 'category',splitLine:{show:false},axisTick:{show:false},axisLine: {show:false},data: xline,axisLabel:{fontSize: 12,color:'#eee',}},
					series: [{ data: seriesline, type: 'bar',  itemStyle: { normal: { color: '#5b8ff9', } }, barWidth:18,}] };
				chart.setOption(option);   
			},	
			
			//补链强链企业区域分布
			areagdpFun(el,data){
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var hgsj = echarts.init(document.getElementById(el)); 
				var _this = this; 
					// for(var i =0;i<data.length;i++){
					// 	data[i].name = data[i].areaName;
					// 	data[i].value = data[i].jj0101
					// } 
				var option = {
				  title: {
				    text: ' ', 
				  },
				  tooltip: {
				    trigger: 'item'
				  },
				  legend: {show:false,top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				  },
				  series: [
				    {
				      name: '',
				      type: 'pie',
				      radius: '60%',
										center: ["50%", "50%"],
				      data: data,
											label: { show:true,  color: '#eee',  fontSize: 11,   position: 'outside',  formatter: '{b} : {d}%', },
				      emphasis: {
				        itemStyle: {
				          shadowBlur: 10,
				          shadowOffsetX: 0,
				          shadowColor: 'rgba(0, 0, 0, 0.5)'
				        }
				      }
				    }
				  ]
				};
				hgsj.setOption(option);   
				// var startCharts = null;
				// // 2、鼠标移动上去的时候的高亮动画
				// hgsj.on('mouseover', function(param) {
				// 	isSet = false
				// 	clearInterval(startCharts)
				// 	// 取消之前高亮的图形
				// 	hgsj.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 高亮当前图形
				// 	hgsj.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// 	// 显示 tooltip
				// 	hgsj.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// });
				// var chartHover = function() {
				// 	var dataLen = option.series[0].data.length
				// 	// 取消之前高亮的图形
				// 	hgsj.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 	// 高亮当前图形
				// 	hgsj.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 显示 tooltip
				// 	hgsj.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// }
				// startCharts = setInterval(chartHover, 2000)
				// // 4、鼠标移出之后，恢复自动高亮
				// hgsj.on('mouseout', function(param) {
				// 	if (!isSet) {
				// 		startCharts = setInterval(chartHover, 2000)
				// 		isSet = true
				// 	}
				// });
			}, 
			
 		}
	}
</script>

<style scoped="scoped"> 
</style>
